// @flow

import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

type Props = {
    children: any
};

function Code(props: Props) {
    const { children } = props;

    return <pre>{children}</pre>;
}

Code.propTypes = {
    children: PropTypes.any.isRequired
};

export default Code;
